import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { CanvasService } from './canvas.service';
import { FunctionService } from 'vhobjects-service';

@Component({
  selector: 'atw-edit-image',
  templateUrl: './edit-image.component.html',
  styleUrls: ['./edit-image.component.scss']
})
export class AtwEditImage implements OnInit {
  @Input() objectChoosing: any;
  @Input() staticdata: any;
  @Input() device: any;
  tab: number = 0;

  // Thuộc tính nén ảnh
  compressWidth = 100;
  compressHeight = 100;
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false; // biến kiểm tra khi đang xử lý dữ liệu
  resolution: any;
  subproject: any;

  // Thuộc tính canvas
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  image = new Image();
  fileImg = {
    name: 'image',
    type: 'image/png',
    extension: 'png'
  }
  cursorCanvas = 'default';
  
  // Thuộc tính zoom
  scale = 1;
  minScale = 0.1;
  maxScale = 10;
  offsetX = 0;
  offsetY = 0;
  currentZoom = 100;
  
  // Thuộc tính kéo
  isDragging = false;
  private lastX = 0;
  private lastY = 0;

  // Trạng thái công cụ
  activeTool: string = 'select';
  showGrid = false;

  // Biến mới cho chức năng crop và rotate
  isCropping = false;
  isDraggingCrop = false;
  dragStartX = 0;
  dragStartY = 0;
  cropDragOffsetX = 0;
  cropDragOffsetY = 0;
  private cropStartX = 0;
  private cropStartY = 0;
  private cropEndX = 0;
  private cropEndY = 0;
  cropCustomSize = { width: 50, height: 50 };
  private isResizingCrop = false;
  private resizeHandle = '';
  private cropHandles: {x: number, y: number, type: string, cursor: string}[] = [];
  originalImage!: HTMLImageElement; // Lưu ảnh gốc để reset khi cần
  minCrop = 10;
  menuOpenMap: any = {
    cropImage: false, 
    rotateImage: false, 
    removeBackground: false, 
    drawOnImage: false, 
    addLogo: false
  };

  // Biến mới cho chức năng rotate
  rotationAngle = 0; // Góc xoay hiện tại (độ)

  // Trạng thái vẽ
  isDrawing = false;
  currentTool: string = 'pen';
  currentDrawColor = '#000000';
  currentDrawFillColor = 'transparent';
  isDrawFilling = false;
  currentLineWidth = 5;
  drawingHistory: ImageData[] = [];
  historyIndex = -1;
  lastDrawX = 0;
  lastDrawY = 0;
  isDrawingShape = false;
  startDrawX = 0;
  startDrawY = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AtwEditImage>,
    @Inject(PLATFORM_ID) private platformId: Object,
    private functionService: FunctionService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private changeDetectorRef: ChangeDetectorRef,
    public canvasService: CanvasService,
  ) {}

  ngOnInit(): void {
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );
    this.resolution = this.subproject.resolution;

    this.objectChoosing = this.data.objectChoosing;
    this.staticdata = this.data.staticdata;
    this.device = this.data.device;
    this.image.crossOrigin = '';
  }

  ngAfterViewInit() {
    this.initCanvas();
    this.loadSampleImage();

    this.originalImage = this.image;
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Hàm thực hiện khởi tạo canvas
   */
  private initCanvas(): void {
    this.canvasService.canvas = this.canvasRef.nativeElement;
    this.canvasService.ctx = this.canvasService.canvas.getContext('2d')!;

    // Tạo canvas preview
    this.canvasService.previewCanvas = document.createElement('canvas');
    this.canvasService.previewCtx = this.canvasService.previewCanvas.getContext('2d')!;
    this.canvasService.previewCanvas.width = this.canvasService.canvas.width;
    this.canvasService.previewCanvas.height = this.canvasService.canvas.height;

    this.adjustCanvasSize();
  }

  /**
   * Hàm thực hiện lấy hình từ dữ liệu để load đưa lên canvas
   */
  private loadSampleImage(): void {
    this.image.crossOrigin = '';
    this.image.onload = () => {
      this.resetView();
      this.draw();
    };
    this.image.src = this.staticdata.img[this.device + '_img']; // Thay bằng đường dẫn ảnh của bạn
  }

  draw() {
    this.canvasService.draw(this.canvasRef, this);
  }

  /**
   * Hàm lấy kích thước của canvas hệ thống
   */
  private adjustCanvasSize(): void {
    const canvas = this.canvasRef.nativeElement;
    const container = canvas.parentElement;
    
    if (container) {
      canvas.width = container.clientWidth;
      canvas.height = container.clientHeight;
      this.canvasService.previewCanvas.width = container.clientWidth;
      this.canvasService.previewCanvas.height = container.clientHeight;
    }
  }

  // ==========Các hàm xử lý kéo canvas==========
  /**
   * Hàm xử lý sự kiện khi nhấn chuột
   * @param event Sự kiện nhấn
   * - Bắt đầu kéo canvas
   * - Bắt đầu crop image
   */
  onMouseDown(event: MouseEvent): void {
    if (event.button === 2) { // Chỉ nút trái chuột
      this.isDragging = true;
      this.cursorCanvas = 'grab';
      this.lastX = event.clientX;
      this.lastY = event.clientY;
      event.preventDefault();
      return; 
    }

    if (this.activeTool === 'crop' || this.isCropping) {
      const canvas = this.canvasRef.nativeElement;
      const rect = canvas.getBoundingClientRect();
      const mouseX = (event.clientX - rect.left - this.offsetX) / this.scale;
      const mouseY = (event.clientY - rect.top - this.offsetY) / this.scale;
      
      // Kiểm tra xem có click vào handle nào không
      for (const handle of this.cropHandles) {
        if (this.canvasService.isPointInHandle(mouseX, mouseY, handle, this)) {
          this.isResizingCrop = true;
          this.resizeHandle = handle.type;
          return;
        }
      }
      
      // Nếu không click vào handle, kiểm tra có click trong vùng crop không
      if (this.canvasService.isPointInCropArea(mouseX, mouseY, this)) {
        this.isDraggingCrop = true;
        this.dragStartX = mouseX;
        this.dragStartY = mouseY;
        this.cropDragOffsetX = mouseX - Math.min(this.cropStartX, this.cropEndX);
        this.cropDragOffsetY = mouseY - Math.min(this.cropStartY, this.cropEndY);
        return;
      }
      
      // Nếu click ngoài vùng crop, tạo vùng crop mới
      this.cropStartX = mouseX;
      this.cropStartY = mouseY;
      this.cropEndX = mouseX;
      this.cropEndY = mouseY;
    }

    if (this.canvasService.listChoose[this.tab].funcName === 'drawOnImage') {
      if (event.buttons !== 1) return;
      // this.isDrawing = true;
      const pos = this.getMousePos(event);
      this.lastDrawX = pos.x;
      this.lastDrawY = pos.y;
      
      // Nếu là công cụ hình dạng, không cần bắt đầu vẽ ngay
      if (this.currentTool === 'pen' || this.currentTool === 'eraser') {
        this.isDrawing = true;
      } else {
        this.isDrawingShape = true;
        return;
      }
      
      this.canvasService.ctx.beginPath();
      this.canvasService.ctx.moveTo(this.lastDrawX, this.lastDrawY);
    }
  }

  /**
   * Hàm xử lý sự kiện khi di chuyển chuột
   * @param event Sự kiện di chuyển chuột
   * - Kéo canvas
   * - Vẽ khung crop
   */
  onMouseMove(event: MouseEvent): void {
    if (this.isDragging && event.buttons === 2 && this.allowDragAndZoom) {
      this.cursorCanvas = 'grabbing';

      const dx = event.clientX - this.lastX;
      const dy = event.clientY - this.lastY;
      
      this.offsetX += dx;
      this.offsetY += dy;
      
      this.lastX = event.clientX;
      this.lastY = event.clientY;
      
      this.draw();
      // return;
    }

    if (this.activeTool === 'crop' || this.isCropping) {
      const canvas = this.canvasRef.nativeElement;
      const rect = canvas.getBoundingClientRect();
      const mouseX = (event.clientX - rect.left - this.offsetX) / this.scale;
      const mouseY = (event.clientY - rect.top - this.offsetY) / this.scale;

      if (event.buttons !== 1) {
        // Gán cursor tương ứng với handle nào được hover
        const handleSize = 8;
        for (const handle of this.cropHandles) {
          const left = handle.x - handleSize / 2;
          const top = handle.y - handleSize / 2;
          const right = handle.x + handleSize / 2;
          const bottom = handle.y + handleSize / 2;

          if (mouseX >= left && mouseX <= right && mouseY >= top && mouseY <= bottom) {
            canvas.style.cursor = handle.cursor;
            this.resizeHandle = handle.type;
            return;
          }
        }

        canvas.style.cursor = 'all-scroll';
        this.resizeHandle = '';
      }
      
      if (event.buttons === 1) { // Chỉ khi đang giữ chuột trái
        if (this.isResizingCrop) {
          this.resizeCropArea(mouseX, mouseY);
        } else if (this.isDraggingCrop) {
          this.dragCropArea(mouseX, mouseY);
        } else {
          this.cropEndX = mouseX;
          this.cropEndY = mouseY;
        }
        
        this.updateCropHandles();
        this.draw();
        this.updateCropCustomSize();
      }
    }

    if (this.canvasService.listChoose[this.tab].funcName === 'drawOnImage') {
      if (event.buttons !== 1) return;
      if (!this.isDrawing || !this.isDrawingShape) return;
    
      const pos = this.getMousePos(event);
      const currentX = pos.x;
      const currentY = pos.y;

      // // Xóa preview trước đó
      // this.canvasService.clearPreview();
      
      // Vẽ preview cho các công cụ hình dạng
      if (['rectangle', 'circle', 'line', 'arrow', 'triangle'].includes(this.currentTool)) {
        this.canvasService.drawPreview(this.lastDrawX, this.lastDrawY, currentX, currentY, this);
        return;
      }

      if (this.isDrawing) {
        switch (this.currentTool) {
          case 'pen':
            // this.canvasService.ctx.globalCompositeOperation = 'source-over';
            this.canvasService.ctx.lineTo(currentX, currentY);
            this.canvasService.ctx.strokeStyle = this.currentDrawColor;
            this.canvasService.ctx.lineWidth = this.currentLineWidth;
            this.canvasService.ctx.stroke();
            this.lastDrawX = currentX;
            this.lastDrawY = currentY;
            break;
            
          case 'eraser':
            this.canvasService.ctx.lineTo(currentX, currentY);
            this.canvasService.ctx.globalCompositeOperation = 'destination-out';
            this.canvasService.ctx.lineWidth = this.currentLineWidth;
            this.canvasService.ctx.stroke();
            this.canvasService.ctx.globalCompositeOperation = 'source-over';
            this.lastDrawX = currentX;
            this.lastDrawY = currentY;
            break;
        }
  
        this.canvasService.ctx.lineJoin = 'round';
        this.canvasService.ctx.lineCap = 'round';
      } else if (this.isDrawingShape) {
        // Khôi phục trạng thái trước khi vẽ hình (để preview)
        this.canvasService.clearPreview();
        
        // Vẽ hình preview - BỔ SUNG THÊM ĐOẠN NÀY ĐỂ KHẮC PHỤC NÉT ĐỨT
        this.canvasService.ctx.save(); // Lưu trạng thái hiện tại của context
        this.canvasService.ctx.strokeStyle = this.currentDrawColor;
        this.canvasService.ctx.lineWidth = this.currentLineWidth;
        this.canvasService.ctx.setLineDash([]); // ĐẢM BẢO KHÔNG CÓ NÉT ĐỨT
        this.canvasService.ctx.beginPath();
        
        if (this.currentTool === 'circle') {
          const radius = Math.sqrt(
            Math.pow(currentX - this.startDrawX, 2) + 
            Math.pow(currentY - this.startDrawY, 2)
          );
          this.canvasService.ctx.arc(this.startDrawX, this.startDrawY, radius, 0, Math.PI * 2);
        } else if (this.currentTool === 'square') {
          const width = currentX - this.startDrawX;
          const height = currentY - this.startDrawY;
          this.canvasService.ctx.rect(this.startDrawX, this.startDrawY, width, height);
        }

        // Đảm bảo fill và stroke đúng cách
        this.canvasService.ctx.fillStyle = this.currentDrawColor;
        this.canvasService.ctx.fill();
        this.canvasService.ctx.stroke();
        this.canvasService.ctx.restore(); // Khôi phục trạng thái context
      }
    }
  }

  /**
   * Hàm xử lý sự kiện khi thả chuột
   * - Kết thúc kéo canvas
   */
  async onMouseUp(event: MouseEvent) {
    this.isDragging = false;
    this.cursorCanvas = 'default';

    if (this.activeTool === 'crop' || this.isCropping) {
      this.isResizingCrop = false;
      this.isDraggingCrop = false;
      this.resizeHandle = '';
      await this.updatePreview('crop');
    }

    if (this.canvasService.listChoose[this.tab].funcName === 'drawOnImage') {
      if (event.buttons !== 1) return;
      if (!this.isDrawing && !this.isDrawingShape) return;
    
      const pos = this.getMousePos(event);
      const currentX = pos.x;
      const currentY = pos.y;

      // Xóa preview
      this.canvasService.clearPreview();
      
      // Vẽ hình dạng thực sự lên canvas chính
      this.canvasService.previewCtx.globalCompositeOperation = 'source-over';
      this.canvasService.previewCtx.strokeStyle = this.currentDrawColor;
      this.canvasService.previewCtx.lineWidth = this.currentLineWidth;
      this.canvasService.previewCtx.setLineDash([]); // Đường liền nét
      
      switch (this.currentTool) {
        case 'rectangle':
          this.canvasService.drawRectangle(this.lastDrawX, this.lastDrawY, currentX, currentY);
          break;
          
        case 'circle':
          this.canvasService.drawCircle(this.lastDrawX, this.lastDrawY, currentX, currentY);
          break;
          
        case 'line':
          this.canvasService.drawLine(this.lastDrawX, this.lastDrawY, currentX, currentY, false, this);
          break;
          
        case 'arrow':
          this.canvasService.drawLine(this.lastDrawX, this.lastDrawY, currentX, currentY, true, this);
          break;
          
        case 'triangle':
          this.canvasService.drawTriangle(this.lastDrawX, this.lastDrawY, currentX, currentY);
          break;
      }
      
      this.isDrawing = false;
      this.isDrawingShape = false;
      this.saveState();
    }
  }

  onRightClick(event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  get allowDragAndZoom(): boolean {
    const tab = this.canvasService.listChoose[this.tab];
    return !this.isCropping && tab.funcName !== 'drawOnImage';
  }

  // ==========Các công cụ chỉnh sửa==========
  /**
   * Bật chế độ crop
   */
  async startCrop(): Promise<void> {
    this.activeTool = 'crop';
    this.cursorCanvas = 'all-scroll';
    this.isCropping = true;
    this.showGrid = true;

    this.setDisabledItemChoose(false);

    // Nếu đang có vùng crop, giữ nguyên
    // Nếu không, tạo vùng crop mặc định bằng 80% ảnh
    if (this.cropStartX === 0 && this.cropStartY === 0 && 
      this.cropEndX === 0 && this.cropEndY === 0) {
      this.cropStartX = this.image.width * 0.1;
      this.cropStartY = this.image.height * 0.1;
      this.cropEndX = this.image.width * 0.9;
      this.cropEndY = this.image.height * 0.9;
    }
    
    this.updateCropHandles();
    this.draw();
    this.updateCropCustomSize();
    await this.updatePreview('crop');
  }

  setDisabledItemChoose(isReset = true): void {
    Object.keys(this.menuOpenMap).forEach(key => {
      this.menuOpenMap[key] = !isReset;

      if (!isReset && key === this.canvasService.listChoose[this.tab].funcName) {
        this.menuOpenMap[key] = !(this.isCropping || this.rotationAngle !== 0);
      }
    });
  }

  /**
   * option crop
   */
  handleCrop(type: string): void {
    const minWidth = Math.min(this.image.width, this.image.height);
    const start = 0;
    const end = 1;
    switch (type) {
      case '1:1':
        this.cropStartX = minWidth * start;
        this.cropStartY = minWidth * start;
        this.cropEndX = minWidth * end;
        this.cropEndY = minWidth * end;
        break;
      case 'custom':
        this.cropStartX = 0;
        this.cropStartY = 0;
        this.cropEndX = this.cropCustomSize.width;
        this.cropEndY = this.cropCustomSize.height;
        break;
      default:
        if (type.includes(':')) {
          const ratio = type.split(':');
          if (+ratio[0] === 0 || +ratio[1] === 0) return;
          if (+ratio[0] <= +ratio[1]) {
            this.cropStartX = minWidth * start;
            this.cropStartY = minWidth * +ratio[0] / +ratio[1] * start;
            this.cropEndX = minWidth * +ratio[0] / +ratio[1] * end;
            this.cropEndY = minWidth * end;
          } else {
            this.cropStartX = minWidth * +ratio[1] / +ratio[0] * start;
            this.cropStartY = minWidth * start;
            this.cropEndX = minWidth * end ;
            this.cropEndY = minWidth * +ratio[1] / +ratio[0] * end;
          }
        }
        break;
    }

    // Nếu đang có vùng crop, giữ nguyên
    // Nếu không, tạo vùng crop mặc định bằng 80% ảnh
    if (this.cropStartX === 0 && this.cropStartY === 0 && 
      this.cropEndX === 0 && this.cropEndY === 0) {
      this.cropStartX = this.image.width * 0.1;
      this.cropStartY = this.image.height * 0.1;
      this.cropEndX = this.image.width * 0.9;
      this.cropEndY = this.image.height * 0.9;
    }
    
    this.updateCropHandles();
    this.draw();
    this.updateCropCustomSize();
  }

  // Cập nhật các handle điều chỉnh
  private updateCropHandles(): void {
    const x = Math.min(this.cropStartX, this.cropEndX);
    const y = Math.min(this.cropStartY, this.cropEndY);
    const width = Math.abs(this.cropEndX - this.cropStartX);
    const height = Math.abs(this.cropEndY - this.cropStartY);
    
    this.cropHandles = [
      { x: x, y: y, type: 'nw', cursor: 'nwse-resize' },          // Góc trên trái
      { x: x + width/2, y: y, type: 'n', cursor: 'ns-resize' }, // Giữa trên
      { x: x + width, y: y, type: 'ne', cursor: 'nesw-resize' },  // Góc trên phải
      { x: x, y: y + height/2, type: 'w', cursor: 'ew-resize' }, // Giữa trái
      { x: x + width, y: y + height/2, type: 'e', cursor: 'ew-resize' }, // Giữa phải
      { x: x, y: y + height, type: 'sw', cursor: 'nesw-resize' }, // Góc dưới trái
      { x: x + width/2, y: y + height, type: 's', cursor: 'ns-resize' }, // Giữa dưới
      { x: x + width, y: y + height, type: 'se', cursor: 'nwse-resize' }  // Góc dưới phải
    ];
  }

  // Điều chỉnh kích thước vùng crop
  private resizeCropArea(mouseX: number, mouseY: number): void {
    const minSize = 10; // Kích thước tối thiểu
    
    switch (this.resizeHandle) {
      case 'nw':
        this.cropStartX = mouseX;
        this.cropStartY = mouseY;
        break;
      case 'n':
        this.cropStartY = mouseY;
        break;
      case 'ne':
        this.cropEndX = mouseX;
        this.cropStartY = mouseY;
        break;
      case 'w':
        this.cropStartX = mouseX;
        break;
      case 'e':
        this.cropEndX = mouseX;
        break;
      case 'sw':
        this.cropStartX = mouseX;
        this.cropEndY = mouseY;
        break;
      case 's':
        this.cropEndY = mouseY;
        break;
      case 'se':
        this.cropEndX = mouseX;
        this.cropEndY = mouseY;
        break;
    }
    
    // Đảm bảo kích thước tối thiểu
    if (Math.abs(this.cropEndX - this.cropStartX) < minSize) {
      if (this.resizeHandle.includes('e')) this.cropEndX = this.cropStartX + minSize;
      else this.cropStartX = this.cropEndX - minSize;
    }
    
    if (Math.abs(this.cropEndY - this.cropStartY) < minSize) {
      if (this.resizeHandle.includes('s')) this.cropEndY = this.cropStartY + minSize;
      else this.cropStartY = this.cropEndY - minSize;
    }
  }

  // Di chuyển vùng crop
  private dragCropArea(mouseX: number, mouseY: number): void {
    const width = Math.abs(this.cropEndX - this.cropStartX);
    const height = Math.abs(this.cropEndY - this.cropStartY);
    
    const newX = mouseX - this.cropDragOffsetX;
    const newY = mouseY - this.cropDragOffsetY;
    
    // Giới hạn không cho ra khỏi ảnh
    this.cropStartX = Math.max(0, Math.min(this.image.width - width, newX));
    this.cropStartY = Math.max(0, Math.min(this.image.height - height, newY));
    this.cropEndX = this.cropStartX + width;
    this.cropEndY = this.cropStartY + height;
  }

  // Hủy crop
  cancelCrop(): void {
    this.setDisabledItemChoose();
    this.resetCropState();
    this.draw();
  }
  
  // Reset trạng thái crop
  resetCropState(): void {
    this.isCropping = false;
    this.isResizingCrop = false;
    this.isDraggingCrop = false;
    this.cropStartX = this.cropStartY = this.cropEndX = this.cropEndY = 0;
    this.resizeHandle = '';
    this.activeTool = 'select';
    this.updateCropCustomSize();
  }

  /**
   * Hàm xoay ảnh. Hàm chính với tham số isSave
   */
  async rotateImage(isSave: boolean = false): Promise<void> {
    this.activeTool = 'rotate';

    // Thực hiện preview
    await this.updatePreview('rotate');

    // Nếu cần lưu thì gọi hàm lưu
    if (isSave) {
      await this.saveAndUpdateImage('rotate');
    }
  }

  /**
   * Hàm preview ảnh xoay
   * 
   * BUG: Hàm này chưa thực sự update lên preview ảnh
   */
  private async updatePreview(type): Promise<void> {
    const { tempCanvas, newImage } = await this.canvasService.createNewCanvas(type, this);
    
    // Cập nhật ảnh preview
    this.image = newImage;
    this.resetView();
    this.draw();
    this.changeDetectorRef.detectChanges();
  }

  async handleRotate(type: 'right' | 'right90' | 'left' | 'left90' | 'blur' | 'reset') {
    try {
      switch (type) {
        case 'right':
          this.rotationAngle += 10;
          if (this.rotationAngle > 360) {
            this.rotationAngle = 360;
          }
          break;
        case 'right90':
          this.rotationAngle += 90;
          if (this.rotationAngle > 360) {
            this.rotationAngle = 360;
          }
          break;
        case 'left':
          this.rotationAngle -= 10;
          if (this.rotationAngle < -360) {
            this.rotationAngle = -360;
          }
          break;
        case 'left90':
          this.rotationAngle -= 90;
          if (this.rotationAngle < -360) {
            this.rotationAngle = -360;
          }
          break;
        case 'reset':
          this.rotationAngle = 0;
          break;
      }
      this.setDisabledItemChoose(false);
      await this.rotateImage();
    } catch (error) {
      console.error('Error rotating image:', error);
    }
  }

  /**
   * Hàm xoá nền ảnh
   */
  async removeBackground(): Promise<void> {
    this.activeTool = 'removeBackground';
    await this.saveAndUpdateImage('removeBackground');
  }

  private getMousePos(e: MouseEvent): { x: number, y: number } {
    const rect = this.canvasService.canvas.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
  }
  
  private saveState(): void {
    if (this.historyIndex < this.drawingHistory.length - 1) {
      this.drawingHistory = this.drawingHistory.slice(0, this.historyIndex + 1);
    }
    
    const imageData = this.canvasService.ctx.getImageData(0, 0, this.canvasService.canvas.width, this.canvasService.canvas.height);
    this.drawingHistory.push(imageData);
    this.historyIndex++;
    
    if (this.drawingHistory.length > 20) {
      this.drawingHistory.shift();
      this.historyIndex--;
    }
  }
  
  redo(): void {
    if (this.historyIndex >= this.drawingHistory.length - 1) return;
    
    this.historyIndex++;
    this.canvasService.ctx.putImageData(this.drawingHistory[this.historyIndex], 0, 0);
  }

  // Thay đổi công cụ
  setTool(tool: 'pen' | 'eraser' | 'circle' | 'square' | string): void {
    this.currentTool = tool;
  }

  // Thay đổi màu sắc
  setColor(color: string, isFill = false): void {
    if (isFill) this.currentDrawFillColor = color;
    else this.currentDrawColor = color;
  }

  // Thay đổi độ dày nét vẽ
  setLineWidth(width: number): void {
    this.currentLineWidth = width;
  }

  clearCanvas(): void {
    this.canvasService.ctx.clearRect(0, 0, this.canvasService.canvas.width, this.canvasService.canvas.height);
    this.initCanvas();
    this.loadSampleImage(); // Vẽ lại ảnh gốc
    this.saveState();
  }

  /**
   * Hàm chèn logo
   */
  addLogo(): void {
    // Triển khai logic chèn logo
    console.log('Add logo');
  }

  /**
   * Hàm reset view
   */
  resetView(): void {
    this.canvasService.resetView(this.canvasRef, this);
  }

  /**
   * Hàm xử lý thu phóng của mat-slider và mat-form-field input
   * @param event 
   */
  onZoomChange(event) {
    if (this.scale < this.minScale) this.scale = this.minScale;
    else if (this.scale > this.maxScale) this.scale = this.maxScale;
  }

  /**
   * Hàm xử lý thu phóng khi cuộn chuột
   * @param event Sự kiện cuộn chuột
   * @returns void
   * 
   * // @HostListener('window:wheel', ['$event'], {passive: false})
   */
  onWheel(event: WheelEvent): void {
    if (event.ctrlKey) {
      event.preventDefault();
      event.stopPropagation();

      if (!this.allowDragAndZoom) return;
      
      const canvas = this.canvasRef.nativeElement;
      const rect = canvas.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      
      const zoomFactor = event.deltaY < 0 ? 1.1 : 0.9;
      const newScale = Math.max(this.minScale, Math.min(this.maxScale, this.scale * zoomFactor));
      
      this.offsetX = mouseX - zoomFactor * (mouseX - this.offsetX);
      this.offsetY = mouseY - zoomFactor * (mouseY - this.offsetY);
      
      this.scale = this.canvasService.roundNumber(newScale);
      this.currentZoom = Math.round(this.scale * 100);

      if (this.scale <= this.minScale) return;
      if (this.scale >= this.maxScale) return;

      this.draw();
    }
  }

  /**
   * Hàm thực hiện zoom in, zoom out, zoom actual, zoom fit
   * @param type : 'in' | 'out' | 'actual' | 'fit'
   * - 'in' : zoom in - Phóng to ảnh canvas ra
   * - 'out' : zoom out - Thu nhỏ ảnh canvas lại
   * - 'actual' : zoom actual - Zoom ảnh bằng 100% (Kích thước gốc)
   * - 'fit' : zoom fit - Zoom ảnh bằng 3/4 container (Vừa giữ nguyên tỉ lệ ảnh vừa cho vừa với khung hình)
   */
  onZoom(type: 'in' | 'out' | 'actual' | 'fit'): void {
    switch (type) {
      case 'in':
        this.scale = this.canvasService.roundNumber(Math.min(this.scale + 0.1, this.maxScale));
        this.draw();
        break;
      case 'out':
        this.scale = this.canvasService.roundNumber(Math.max(this.scale - 0.1, this.minScale));
        this.draw();
        break;
      case 'actual':
        this.scale = 1;
        this.draw();
        break;
      case 'fit':
        const canvas = this.canvasRef.nativeElement;
        const containerWidth = canvas.clientWidth;
        const containerHeight = canvas.clientHeight;
        
        // Tính tỷ lệ zoom để ảnh bằng 3/4 container (giữ nguyên tỷ lệ)
        const targetWidth = containerWidth * 3 / 4;
        const targetHeight = containerHeight * 3 / 4;
        
        const scaleX = targetWidth / this.image.width;
        const scaleY = targetHeight / this.image.height;
        this.scale = this.canvasService.roundNumber(Math.min(scaleX, scaleY));
        
        // Căn giữa ảnh
        this.offsetX = (containerWidth - this.image.width * this.scale) / 2;
        this.offsetY = (containerHeight - this.image.height * this.scale) / 2;
        
        this.draw();
        break;
    }
  }

  openPopupSaveFileImg() {
    this.fileImg.name = this.canvasService.listChoose[this.tab].fileName;
    this.isShowConfirmPopup = true;
  }

  /**
   * xử lí chuyển tabs
   * @param index
   */
  onChangeTab(index: number) {
    if (isPlatformBrowser(this.platformId)) {
      this.tab = index;

      switch (this.canvasService.listChoose[index].funcName) {
        case 'cropImage':
          this.showGrid = true;
          this.draw();
          break;
        case 'drawOnImage':
          this.canvasService.ctx = this.canvasRef.nativeElement.getContext('2d', { willReadFrequently: true }) as CanvasRenderingContext2D;
          break;
        case 'removeBackground':
        default:
          this.showGrid = false;
          this.draw();
          break;
      }
    }
  }

  async save() {
    switch (this.canvasService.listChoose[this.tab].funcName) {
      case 'cropImage':
        await this.saveAndUpdateImage('crop');
        break;
      case 'rotateImage':
        await this.rotateImage(true);
        break;
      case 'removeBackground':
        this.removeBackground();
        break;
      case 'drawOnImage':
        await this.saveAndUpdateImage('drawOnImage');
        break;
      case 'addLogo':
        this.addLogo();
        break;
    }
    this.setDisabledItemChoose();
    this.isConfirmLoading = false;
    this.isShowConfirmPopup = false;
  }

  undo(): void {
    if (this.canvasService.listChoose[this.tab].funcName === 'drawOnImage') {
      if (this.historyIndex <= 0) return;
    
      this.historyIndex--;
      this.canvasService.ctx.putImageData(this.drawingHistory[this.historyIndex], 0, 0);
      
      return;
    }

    this.activeTool = 'select';
    this.image = this.originalImage;
    this.initCanvas();
    this.draw();
    this.updateImage(this.image.src);
    const messageMap = {
      cropImage: 'da_tra_ve_anh_truoc_khi_cat',
      rotateImage: 'da_tra_ve_anh_truoc_khi_xoay',
      removeBackground: 'da_tra_ve_anh_truoc_khi_xoa_nen',
      drawOnImage: 'da_tra_ve_anh_truoc_khi_ve_len',
      addLogo: 'da_tra_ve_anh_truoc_khi_chen_logo',
    };
    this.functionService.createMessage('success', messageMap[this.canvasService.listChoose[this.tab].funcName]);
  }

  private async saveAndUpdateImage(type): Promise<void> {
    const { tempCanvas } = await this.canvasService.createNewCanvas(type, this);
    await this.canvasService.saveNewImage(this, this.objectChoosing, tempCanvas);
  }

  // toggleFullscreen() {
  //   const elem = document.querySelector('.image-preview');
  //   if (elem?.requestFullscreen) {
  //     elem.requestFullscreen();
  //   }
  // }

  updateCropCustomSize() {
    if (this.canvasService.listChoose[this.tab].funcName == 'cropImage') {
      this.cropCustomSize = {
        width: Math.abs(this.cropEndX - this.cropStartX),
        height: Math.abs(this.cropEndY - this.cropStartY)
      }
      if (!this.cropStartX && !this.cropStartY && !this.cropEndX && !this.cropEndY)
        this.cropCustomSize = { width: 0, height: 0 };
    }
  }

  /**
   * Hàm update hình lên server
   * @param url đường dẫn hình cần update
   * @returns 
   */
  updateImage(url: string) {
    if (this.objectChoosing.setups.upload_image.display == 'shared') {
      this.functionService.devices.forEach((device) => {
        this.staticdata.img[device.value + '_img'] = url;
      });
    } else {
      this.staticdata.img[this.device + '_img'] = url;
    }
   
    if (this.functionService.getTypeConfig() == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata');
      return;
    }

    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata, })
      .then((bool: any) => {
        if (bool) {
          // clear tool
          this.isCropping = false;
          this.rotationAngle = 0;

          this.initCanvas();
          this.loadSampleImage();
        }
      });
  }

  /**
   * Cập nhật Setups vào database.
   */
  updateSetups() {
    if (this.functionService.getTypeConfig() == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('setups')) this.objectChoosing['fieldUpdate'].push('setups')
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      setups: this.objectChoosing.setups,
    });
  }
}
